import {
  Box,
  Typography,
  TextField,
  styled,
  InputAdornment,
} from "@mui/material";
import React from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    minHeight: "25px", // Set minimum height
    padding: "8px 14px 8px 14px", // comfortable left padding (was 3px)
  },
  "& .MuiInputBase-input": {
    minHeight: "25px", // Ensure input field has a minimum height
    overflow: "hidden",
    paddingLeft: "0.5rem",
  },
  "&.highlight-disabled .MuiInputBase-input.Mui-disabled": {
    color: "#090808",
    cursor: "not-allowed",
    opacity: 1,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "#090808",
  },
}));

const InputField = ({
  title,
  adornmentText,
  handleChange,
  placeholder,
  value,
  errors,
  disabled,
  fieldName,
  showIcon,
  ellipsis,
  mt,
  labelMinHeight,
  inputSx,
  inputProps,
  /** When true, no label row is rendered (e.g. inline next to another control). */
  hideTitle = false,
  /** When true, validation message is not shown under the field (parent can render errors). */
  hideErrorTypography = false,
}) => {
  return (
    <Box>
      {!hideTitle ? (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            mt: mt || 1,
            minHeight: labelMinHeight || "auto",
          }}
        >
          {title}
        </Typography>
      ) : null}
      <CustomTextField
        sx={{ mt: hideTitle ? 0 : mt, ...(inputSx || {}) }}
        variant="outlined"
        value={value === 0 ? 0 : value || ""}
        disabled={disabled}
        onChange={handleChange}
        fullWidth
        name={fieldName}
        placeholder={placeholder}
        error={!!errors}
        className={disabled ? "highlight-disabled" : ""}
        multiline={ellipsis ? false : true} // Allows text to grow dynamically
        minRows={1} // Ensures at least one row is visible
        maxRows={Infinity} // Allows the text field to expand as needed
        InputLabelProps={{
          style: { color: errors ? "#D34040" : undefined },
        }}
        inputProps={inputProps}
        InputProps={{
          endAdornment:
            (showIcon && <TaskAltIcon sx={{ color: "green" }} />) ||
            (adornmentText && (
              <InputAdornment position="end">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                    maxWidth: { xs: "120px", sm: "none" },
                    fontSize: "13px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      height: "29px",
                      width: "1px",
                      bgcolor: "#8A8A8A",
                      marginRight: "8px",
                    }}
                  />
                  {adornmentText}
                </Box>
              </InputAdornment>
            )),
        }}
      />
      {errors && typeof errors === "string" && !hideErrorTypography && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default InputField;
